import React from 'react'
import { Stack } from '@mantine/core'
import LabeledContainer from '../../../components/LabeledContainer'
import ReportWrapper from '../ReportWrapper'
import DataDisclaimer from './DataDisclaimer'
import RelatedCompaniesSummary from './RelatedCompaniesSummary'
import RelatedCompaniesList from './RelatedCompaniesList'
import { RelatedCompaniesData, RelatedCompanyItem } from './types'

interface TianyanchaRelatedCompaniesProps {
  data: any
  title: string
}

const TianyanchaRelatedCompanies: React.FC<TianyanchaRelatedCompaniesProps> = ({ data, title }) => {
  const jsonData: RelatedCompaniesData = JSON.parse(data.tianyancha_related_companies ?? '{}')
  const companies: RelatedCompanyItem[] = jsonData?.items || []

  return (
    <ReportWrapper>
      <LabeledContainer title={title} />
      <Stack>
        <RelatedCompaniesSummary companies={companies} />
        <RelatedCompaniesList companies={companies} />
        <DataDisclaimer />
      </Stack>
    </ReportWrapper>
  )
}

export default TianyanchaRelatedCompanies
